module.exports = __webpack_public_path__ + "5b8a1895b524536c9fb1cf385f93e3e7.pdf";